module.exports = __webpack_public_path__ + "e058d4229de0ed6f66934eb23daffef9.jpg";